import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './index.css';

class Button extends Component {
  render() {
    const {
      children,
      className,
      onClick,
      type,
      disabled,
      text,
      ...rest
    } = this.props;
    const BtnCSS = cn('button', className);
    return (
      <button
        type={type}
        disabled={disabled}
        className={BtnCSS}
        onClick={onClick}
        {...rest}
      >
        {children || text}
      </button>
    );
  }
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  text: PropTypes.string,
};

export default Button;



// WEBPACK FOOTER //
// ./src/common/components/Button/index.js